class SearchForm extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input[type="search"]');
    this.resetButton = this.querySelector('button[type="reset"]');

    if (this.input) {
      this.input.form.addEventListener('reset', this.onFormReset.bind(this));
      this.input.addEventListener(
        'input',
        debounce((event) => {
          this.onChange(event);
        }, 300).bind(this)
      );
    }
  }

  toggleResetButton() {
    const resetIsHidden = this.resetButton.classList.contains('hidden');
    if (this.input.value.length > 0 && resetIsHidden) {
      this.resetButton.classList.remove('hidden');
    } else if (this.input.value.length === 0 && !resetIsHidden) {
      this.resetButton.classList.add('hidden');
    }
  }

  onChange() {
    this.toggleResetButton();
  }

  shouldResetForm() {
    return !document.querySelector('[aria-selected="true"] a');
  }

  onFormReset(event) {
    // Prevent default so the form reset doesn't set the value gotten from the url on page load
    event.preventDefault();
    // Don't reset if the user has selected an element on the predictive search dropdown
    if (this.shouldResetForm()) {
      this.input.value = '';
      this.input.focus();
      this.toggleResetButton();
    }
  }
}

customElements.define('search-form', SearchForm);



document.addEventListener("DOMContentLoaded", function () {

  const input = document.querySelector("input[name='q']");
  const wrapper = document.querySelector(".predictive-search-wrapper");
  const box = document.querySelector(".predictive-results");

  if (!input || !wrapper || !box) return;

  let debounceTimer;

  input.addEventListener("input", function () {

    const query = input.value.trim();

    clearTimeout(debounceTimer);

    if (query.length < 2) {
      box.style.display = "none";
      box.innerHTML = "";
      return;
    }

    debounceTimer = setTimeout(async function () {

      try {

        const response = await fetch(`/search/suggest.json?q=${encodeURIComponent(query)}&resources[type]=product&resources[limit]=4`);

        const data = await response.json();

        const products = data?.resources?.results?.products || [];

        if (products.length === 0) {
          box.innerHTML = `<div style="padding:10px">No products found</div>`;
          box.style.display = "block";
          return;
        }

        box.innerHTML = products.map(product => {

          const image = product.featured_image ? product.featured_image.url : "";
          const tags = Array.isArray(product.tags) ? product.tags : [];
          const hasAskPrice = tags.includes("ask_price");


          const price = !hasAskPrice ? `<div style="font-size:22px;color:#00A63E">
             INR ${Number(product.price).toLocaleString("en-IN", {
               minimumFractionDigits: 2,
               maximumFractionDigits: 2
             })}
           </div>` : "";
          

          return `
            <a href="${product.url}" class="predictive-item">
              <img src="${image}" width="90" height="80" loading="lazy">
              <div>
                <div>${product.title}</div>
                ${price}
              </div>
            </a>
          `;

        }).join("");

        box.style.display = "block";

      } catch (error) {

        console.error("Predictive search error:", error);

      }

    }, 300); // debounce delay

  });

  document.addEventListener("click", function (e) {
    if (!wrapper.contains(e.target)) {
      box.style.display = "none";
    }
  });

});